import axios from 'src/utils/axios';

export interface PersonalInfoSummary {
  completed: number;
  total: number;
  account_hub_edit_url: string;
  last_updated: string | null;
  ssn_last_four: string | null;
}

export const getPersonalInfoSummary = (
  memberId?: number | null
): Promise<PersonalInfoSummary> => {
  const url = memberId
    ? `data-vault/personal-info-summary/?member_id=${memberId}`
    : 'data-vault/personal-info-summary/';
  return axios.get<PersonalInfoSummary>(url).then((r) => r.data);
};
